import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { OutputJsonState } from '../interfaces/interface';
import { getOutputJsonTaskStatus, getSavedOutputJson, getTagsViaExcel, getTagsViaPlatform, saveOutputJson, uploadCompletedTask, uploadTaskNames } from '../slices/outputJson';

const ExtraReducers = (builder: ActionReducerMapBuilder<OutputJsonState>) => {
  builder
    .addCase(getTagsViaPlatform.pending, (state) => {
      state.getTagsViaPlatformStatus = STATUS.PENDING;
      state.getTagsViaPlatformMessage = null
    })
    .addCase(getTagsViaPlatform.fulfilled, (state, action: PayloadAction<any>) => {
      state.tagsPlatform.data = action.payload; 
      state.getTagsViaPlatformStatus = STATUS.SUCESS; 
      state.getTagsViaPlatformMessage = null
    })
    .addCase(getTagsViaPlatform.rejected, (state, action:any) => { 
      state.getTagsViaPlatformStatus = STATUS.FAILED;
      state.getTagsViaPlatformMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getOutputJsonTaskStatus.pending, (state, action: PayloadAction<any>) => {
      state.getTaskStatusOutputJson = STATUS.PENDING;
      state.getTaskStatusOutputJsonMessage = null
    })
    .addCase(getOutputJsonTaskStatus.fulfilled, (state, action: PayloadAction<any>) => {
      state.taskStatusOutputJsonResponse = action.payload; 
      state.getTaskStatusOutputJson = STATUS.SUCESS; 
      state.getTaskStatusOutputJsonMessage = action?.payload.message || 'success'
    })
    .addCase(getOutputJsonTaskStatus.rejected, (state, action:any) => { 
      state.taskStatusOutputJsonResponse = action.payload;
      state.getTaskStatusOutputJson = STATUS.FAILED;
      state.getTaskStatusOutputJsonMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getTagsViaExcel.pending, (state) => {
      state.getTagsViaExcelStatus = STATUS.PENDING;
      state.getTagsViaExcelMessage = null
    })
    .addCase(getTagsViaExcel.fulfilled, (state, action: PayloadAction<any>) => {
      state.tagsExcel.data = action.payload; 
      state.getTagsViaExcelStatus = STATUS.SUCESS; 
      state.getTagsViaExcelMessage = null
    })
    .addCase(getTagsViaExcel.rejected, (state, action:any) => { 
      state.getTagsViaExcelStatus = STATUS.FAILED;
      state.getTagsViaExcelMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getSavedOutputJson.pending, (state) => {
      state.getSavedOutputJsonStatus = STATUS.PENDING;
      state.getSavedOutputJsonMessage = null
    })
    .addCase(getSavedOutputJson.fulfilled, (state, action: PayloadAction<any>) => {
      state.data = action.payload; 
      state.getSavedOutputJsonStatus = STATUS.SUCESS; 
      state.getSavedOutputJsonMessage = null
    })
    .addCase(getSavedOutputJson.rejected, (state, action:any) => { 
      state.getSavedOutputJsonStatus = STATUS.FAILED;
      state.getSavedOutputJsonMessage = action.payload?.message || "An error occurred"
    })
    .addCase(uploadTaskNames.pending, (state) => {
      state.uploadTaskNamesStatus = STATUS.PENDING;
      state.uploadTaskNamesMessage = null
    })
    .addCase(uploadTaskNames.fulfilled, (state, action: PayloadAction<any>) => {
      state.data = action.payload; 
      state.uploadTaskNamesStatus = STATUS.SUCESS; 
      state.uploadTaskNamesMessage = null
    })
    .addCase(uploadTaskNames.rejected, (state, action:any) => { 
      state.uploadTaskNamesStatus = STATUS.FAILED;
      state.uploadTaskNamesMessage = action.payload?.message || "An error occurred"
    })
    .addCase(uploadCompletedTask.pending, (state) => {
      state.uploadCompletedTaskStatus = STATUS.PENDING;
      state.uploadCompletedTaskMessage = null
    })
    .addCase(uploadCompletedTask.fulfilled, (state, action: PayloadAction<any>) => {
      state.data = action.payload; 
      state.uploadCompletedTaskStatus = STATUS.SUCESS; 
      state.uploadCompletedTaskMessage = null
    })
    .addCase(uploadCompletedTask.rejected, (state, action:any) => { 
      state.uploadCompletedTaskStatus = STATUS.FAILED;
      state.uploadCompletedTaskMessage = action.payload?.message || "An error occurred"
    })
    .addCase(saveOutputJson.pending, (state) => {
      state.saveOutputJsonStatus = STATUS.PENDING;
      state.saveOutputJsonMessage = null
    })
    .addCase(saveOutputJson.fulfilled, (state, action: PayloadAction<any>) => {
      state.saveoutputJsonResponse.data = action.payload; 
      state.saveOutputJsonStatus = STATUS.SUCESS; 
      state.saveOutputJsonMessage = action?.payload.message || 'success'
    })
    .addCase(saveOutputJson.rejected, (state, action:any) => { 
      state.saveOutputJsonStatus = STATUS.FAILED;
      state.saveOutputJsonMessage = action.payload?.message || "An error occurred"
    })
};

export default ExtraReducers;
